import React from 'react';

type Props = {
  width?: string;
  height?: string;
  fill?: string;
};

export const IconSpyUser = ({ width = '24px', height = '24px', fill = '#000' }: Props) => {
  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-label="spy">
      <g>
        <path
          fill={fill}
          d="M7.5 7.2L16.5 7.2 15.2 4.1 8.8 4.1 7.5 7.2Z"
        />
        <rect x="5" y="7.2" width="14" height="1.6" rx="0.8" fill={fill} />

        <circle fill={fill} cx="9" cy="10.3" r="2" />
        <circle fill={fill} cx="15" cy="10.3" r="2" />
        <rect x="10.9" y="9.9" width="2.2" height="0.8" rx="0.4" fill={fill} />

        <rect x="6.6" y="10" width="0.9" height="0.6" rx="0.3" fill={fill} />
        <rect x="16.5" y="10" width="0.9" height="0.6" rx="0.3" fill={fill} />

        <path
          fill={fill}
          opacity={0.3}
          d="M14,12.6H10c-4.06,0-5.5,2.97-5.5,5.52 0,2.28 1.21,3.48 3.5,3.48H16c2.29,0 3.5-1.2 3.5-3.48 0-2.55-1.44-5.52-5.5-5.52Z"
        />
        <path
          fill={fill}
          d="M6.2 12.8L9.8 12.8 8 20.5 6.6 20.5 6.2 12.8Z"
        />
        <path
          fill={fill}
          d="M17.8 12.8L14.2 12.8 16 20.5 17.4 20.5 17.8 12.8Z"
        />
      </g>
    </svg>
  );
};

export default IconSpyUser;